<iframe id="inlineFrameExample"  style="height: 70vh"
        title="Tarification Frame"
        width="100%"
        height="100%"
        src="http://197.13.15.234/mutuelle_direct/index_afps.php?id_opp={{opportunity_id}}&api_key={{apikey}}">
</iframe>
